import React, { useContext, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import SimpleBar from 'simplebar-react'
import { AppHeader } from 'components/header/AppHeader'
import { AppFooter } from 'components/footer/AppFooter'
import { setAppStartAudioPlayed } from 'store/actions/global'
import IncomingCalls from 'components/pages/call/components/IncomingCalls'
import { KeypadModal, Loading, TransferCallContactsModal } from 'components/shared'
import { AppContext } from 'common/Globals'
import Logger from 'common/Logger'

export const Layout = ({ component, withoutLayout, withoutFooter, ...restProps }) => {
    const dispatch = useDispatch()
    const containerRef = useRef(null)
    const scrollContainerRef = useRef(null)

    const TagName = component

    const authData = useSelector((state) => state.auth)
    const { volume } = useSelector((state) => state.settings)
    const { appStartAudioPlayed } = useSelector((state) => state.global)

    const isLoading = authData?.loading
    const { isUserAuthed } = useContext(AppContext)

    const [audio, setAudio] = useState()

    useEffect(() => {
        if(!isUserAuthed) return;

        const _audio = new Audio('/audio/app_start.mp3')
        _audio.volume = 0.01 * volume
        _audio.load();
        _audio.addEventListener('canplaythrough', () => setAudio(_audio))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isUserAuthed])

    useEffect(() => {
        if (!audio || appStartAudioPlayed) return

        audio.play().then(() => {
            dispatch(setAppStartAudioPlayed())
        }).catch((err) => {
            Logger.warn(err)
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [audio])

    useEffect(() => {
        if (containerRef?.current) {
            sessionStorage.setItem('appHeight', containerRef.current.getBoundingClientRect().height)
        }
    }, [containerRef])

    function renderLoading() {
        return isLoading ? (
            <div className="app__loading">
                <Loading />
            </div>
        ) : null
    }

    return (
        <>
            {renderLoading()}
            {withoutLayout ? (
                <TagName {...restProps} />
            ) : (
                <>
                    <div className="app__page-body">
                        <AppHeader />
                        <SimpleBar ref={scrollContainerRef} className="app__page-content">
                            <TagName {...restProps} scrollContainerRef={scrollContainerRef} />
                        </SimpleBar>
                        {!withoutFooter && <AppFooter />}
                    </div>
                    <TransferCallContactsModal />
                    <KeypadModal />
                    <IncomingCalls />
                </>
            )}
        </>
    )
}
